export default __webpack_public_path__ + "static/media/detail-page-banner.e579365d.jpg";